<template>
  <router-view :key="$route.params.announcement_id" />
</template>

<script>
export default {
  mounted() {
    this.$store.commit('adminPanel/setViewTitle', {
      depth: 0,
      title: 'Announcements',
      to: { name: 'announcement-listing' },
    });
  },
};
</script>

<style></style>
